/*
  Card title ticker: wraps each product card title in the one-line ticker markup styled in
  product-card-frame.css (.mcg-mq). The title is printed twice (the copy is aria-hidden); CSS decides
  whether it scrolls, so short titles stay still. Runs on load and on cards added later
  (filters, sorting, pagination, theme editor).
  The same pass renames the compact quick add label "Add" to "Add to cart": the button opens on hover
  into that label, matching the dock button (quick-add-compact.css). Pre-order and Options stay as they are.
*/
(function () {
  function wrap(root) {
    var links = (root || document).querySelectorAll('.product-card-wrapper .card__heading > a:not([data-mcg-mq])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var text = a.textContent.replace(/\s+/g, ' ').trim();
      if (!text) continue;
      a.setAttribute('data-mcg-mq', '');
      var mq = document.createElement('span');
      mq.className = 'mcg-mq';
      var track = document.createElement('span');
      track.className = 'mcg-mq__track';
      var one = document.createElement('span');
      one.className = 'mcg-mq__item';
      one.textContent = text;
      var two = one.cloneNode(true);
      two.setAttribute('aria-hidden', 'true');
      track.appendChild(one);
      track.appendChild(two);
      mq.appendChild(track);
      a.textContent = '';
      a.appendChild(mq);
    }

    var labels = (root || document).querySelectorAll('.quick-add--compact .quick-add__label:not([data-mcg-label])');
    for (var j = 0; j < labels.length; j++) {
      var l = labels[j];
      l.setAttribute('data-mcg-label', '');
      if (l.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === 'add') l.textContent = 'Add to cart';
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      wrap();
    });
  }

  wrap();
  document.addEventListener('DOMContentLoaded', queue);
  document.addEventListener('shopify:section:load', queue);
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          queue();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/*
  Phones and tablets (no hover): the product card row nearest the middle of the screen
  glows and shows its second photo, the way a hovered card does on desktop. Updates as the
  page or a swipe row scrolls. Styles: .mcg-in-view in product-card-frame.css.

  MCG perf: the browser reports which cards cross a thin band across the middle of the screen
  (IntersectionObserver), so nothing is measured on scroll frames. Card positions are read only
  when that set changes, to pick the single row nearest the middle.
*/
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var inBand = new Set();
  var current = [];
  var queued = false;

  function apply() {
    queued = false;
    var mid = window.innerHeight / 2;
    var vw = window.innerWidth;
    var best = Infinity;
    var rows = [];

    inBand.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      if (r.height === 0 || cx < 0 || cx > vw) return;
      var d = Math.abs(r.top + r.height / 2 - mid);
      rows.push({ el: el, d: d });
      if (d < best) best = d;
    });

    var next = rows.filter(function (c) { return c.d - best < 12; }).map(function (c) { return c.el; });

    current.forEach(function (el) {
      if (next.indexOf(el) === -1) el.classList.remove('mcg-in-view');
    });
    next.forEach(function (el) {
      el.classList.add('mcg-in-view');
    });
    current = next;
  }

  function queue() {
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(apply);
    }
  }

  var thresholds = [];
  for (var t = 0; t <= 1; t += 0.05) thresholds.push(Math.round(t * 100) / 100);

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        var w = e.boundingClientRect.width;
        var half = w > 0 && e.intersectionRect.width >= w / 2;
        if (e.isIntersecting && half) inBand.add(e.target);
        else inBand.delete(e.target);
      });
      queue();
    },
    { rootMargin: '-35% 0px -35% 0px', threshold: thresholds }
  );

  var seen = new WeakSet();
  function scan() {
    var cards = document.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      if (!seen.has(cards[i])) {
        seen.add(cards[i]);
        io.observe(cards[i]);
      }
    }
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('resize', queue);
})();

/*
  Home page row headings on phones: "// 01 NOW SPINNING ——— VIEW ALL" stays on one line.
  Each heading keeps its full size when it fits; a longer one shrinks only as much as it needs to fit
  beside its line and View all link (never below 1.6rem). Tablet and desktop keep the stylesheet size.
  Runs again when the fonts finish loading, on resize and when the theme editor reloads a section.
*/
(function () {
  if (!window.matchMedia) return;
  var phone = window.matchMedia('(max-width: 749px)');
  var LINE_MIN = 24;
  var FLOOR = 16;

  function fit() {
    var heads = document.querySelectorAll('.mcg-sec-head');
    for (var i = 0; i < heads.length; i++) {
      var head = heads[i];
      var title = head.querySelector('.title');
      if (!title) continue;
      title.style.fontSize = '';
      title.style.whiteSpace = '';
      if (!phone.matches) continue;
      title.style.whiteSpace = 'nowrap';
      var base = parseFloat(window.getComputedStyle(title).fontSize);
      var gap = parseFloat(window.getComputedStyle(head).columnGap) || 0;
      var all = head.querySelector('.mcg-sec-head__all');
      var line = head.querySelector('.mcg-sec-head__line');
      var room = head.clientWidth - (all ? all.offsetWidth + gap : 0) - (line ? LINE_MIN + gap : 0);
      var need = title.scrollWidth;
      if (room > 0 && need > room) {
        title.style.fontSize = Math.max(FLOOR, Math.floor((base * room) / need)) + 'px';
      }
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      fit();
    });
  }

  queue();
  document.addEventListener('DOMContentLoaded', queue);
  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  document.addEventListener('shopify:section:load', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
})();
